const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "NOFRAMES"]);
const done = new WeakMap();
const orig = new WeakMap();
let observer = null;

const variants = (src, dst) => {
  const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  const title = (s) => s.split(" ").map(cap).join(" ");
  return [[src, dst], [src.toLowerCase(), dst.toLowerCase()], [src.toUpperCase(), dst.toUpperCase()], [title(src), title(dst)], [cap(src), cap(dst)]];
};

const buildReplacer = (pairs) => {
  const map = new Map();
  pairs.forEach((p) => variants(p.source, p.target).forEach(([s, t]) => { if (!map.has(s)) map.set(s, t); }));
  const keys = [...map.keys()].sort((a, b) => b.length - a.length).map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  if (!keys.length) return null;
  const rx = new RegExp(`(?<![\\p{L}\\d])(${keys.join("|")})(?![\\p{L}\\d])`, "gu");
  return (text) => text.replace(rx, (m) => map.get(m) ?? m);
};

const skipped = (node) => {
  for (let el = node.parentElement; el; el = el.parentElement) {
    if (SKIP.has(el.tagName) || el.isContentEditable || el.hasAttribute("data-no-terms")) return true;
  }
  return false;
};

const fix = (node, replace) => {
  if (node.nodeType !== 3 || !node.nodeValue.trim() || done.get(node) === node.nodeValue || skipped(node)) return;
  orig.set(node, node.nodeValue);
  const out = replace(node.nodeValue);
  if (out !== node.nodeValue) node.nodeValue = out;
  done.set(node, out);
};

const walk = (root, replace) => {
  if (root.nodeType === 3) { fix(root, replace); return; }
  const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = w.nextNode(); n; n = w.nextNode()) fix(n, replace);
};

export const applyTerms = (pairs) => {
  if (observer) { observer.disconnect(); observer = null; }
  const w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  for (let n = w.nextNode(); n; n = w.nextNode()) {
    if (orig.has(n) && done.get(n) === n.nodeValue) { n.nodeValue = orig.get(n); done.delete(n); }
  }
  const replace = buildReplacer(pairs || []);
  if (!replace) return;
  walk(document.body, replace);
  observer = new MutationObserver((muts) => {
    muts.forEach((m) => {
      if (m.type === "characterData") fix(m.target, replace);
      else m.addedNodes.forEach((n) => walk(n, replace));
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
};
